import operatingCost from '../../fields/cases/operatingCost';

export const MUTATION_UPDATE_OC_CASE = /* GraphQL */ `
	mutation($input: OperatingCostCaseUpdate!, $id: String!) {
		updateOperatingCostCase(input: $input, id: $id) {
			${operatingCost}
		}
	}
`;
